<template>
  <div>
    <AdminHeader />
    <SubNav />
    <router-view :key="key" />
  </div>
</template>
<script>
import AdminHeader from "@/components/common/AdminHeader";
import SubNav from "@/components/common/SubNav";

export default {
  name: "AdminLayout",
  components: {
    AdminHeader,
    SubNav,
  },
  computed: {
    key() {
      return this.$route.path;
    },
  },
};
</script>
